import { Option } from "./Option";
import grafika_1 from "../../assets/grafika_1.svg";
import { ReactComponent as Telefon } from "../../assets/kontakt_telefon.svg";
import { ReactComponent as TelefonSzary } from "../../assets/kontakt_telefon_szary.svg";
import { ReactComponent as Mail } from "../../assets/kontakt_mail.svg";
import { ReactComponent as MailSzary } from "../../assets/kontakt_mail_szary.svg";
import { ReactComponent as GrafikaSzara } from "../../assets/ludzik_szary.svg";

interface IContactProps {
  active: boolean;
}

const Contact = ({ active }: IContactProps) => {
  return (
    <div className="marginTop">
      {active ? (
        <img src={grafika_1} width="220" alt="" />
      ) : (
        <GrafikaSzara width="230" />
      )}

      <div className="contactContainer">
        <span className={`contactHelp ${active ? "" : "grey"}`}>
          Masz pytania?
        </span>
        <span className={`contactHelp red bold ${active ? "" : "grey"}`}>
          Skontaktuj się z nami.
        </span>
      </div>
      <Option
        Image={active ? Telefon : TelefonSzary}
        href="tel:+48225654949"
        active={active}
      >
        +48 22 565 49 49
      </Option>
      <Option
        Image={active ? Mail : MailSzary}
        href="mailto:kontakt@xelion.pl"
        active={active}
      >
        kontakt@xelion.pl
      </Option>
    </div>
  );
};

export { Contact };
